import PackageDialog from "../PackageDialog";
import CreateFolderDialog from "./CreateFolderDialog";
import DeleteFolderDialog from "./DeleteFolderDialog";
import MoveFileToFolderDialog from "./MoveFileToFolderDialog";
import RenameFolderDialog from "./RenameFolderDialog";

const ModalHost = () => {
    return (
        <>
            <PackageDialog />
            <CreateFolderDialog />
            <RenameFolderDialog />
            <DeleteFolderDialog />
            <MoveFileToFolderDialog />
        </>
    );
};

export default ModalHost;
